// The office's Safety reports page in the console (PMU-237): what people reported in Messages and
// Lost and found, and, at a school with Messages, the messages its safeguarding words flagged.
// Registered by both modules (same id, shown once); a report's conversation opens in Messages.
import { Tabs } from "@vavr/ui";
import { navigate, slot } from "@vavr/screens/shared";
import { useConsole } from "@vavr/screens/console";
import { SafeguardingView } from "../messages/screens.tsx";
import { ReportsView } from "./screens.tsx";

export function SafetyPage() {
  const { site } = useConsole();
  const openThread = (id: string) => navigate(`/console/messages?open=${encodeURIComponent(id)}`);
  const reports = <ReportsView siteId={site.id} tz={site.tz} openThread={openThread} />;
  const safeguarding = site.org_kind !== "operator" && slot("console.nav").some((x) => x.id === "messages");
  if (!safeguarding) return reports;
  return (
    <Tabs label="Safety reports" defaultValue="reports" items={[
      { value: "reports", label: "Reports", content: reports },
      { value: "safeguarding", label: "Safeguarding", content: <SafeguardingView siteId={site.id} tz={site.tz} open={openThread} /> },
    ]} />
  );
}

/** The console.nav entry both modules register. */
export const safetyNav = { id: "safety", label: "Safety reports", icon: "shield" as const, path: "safety", title: "Safety reports", permission: "site.configure" as const, group: "Daily", render: () => <SafetyPage /> };
